import { jsx as _jsx } from "react/jsx-runtime";
import { LineStyled } from './styles';
export var getTrendLineLayer = function (trendValue) {
  var TrendLineLayer = function (_a) {
    var yScale = _a.yScale,
      innerWidth = _a.innerWidth;
    var y = yScale(trendValue);
    return _jsx(LineStyled, {
      x1: 0,
      x2: innerWidth,
      y1: y,
      y2: y,
      strokeDasharray: "5 5"
    });
  };
  return TrendLineLayer;
};